import { featureItems } from './mockData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 mb-4">
              <i className="ri-star-line text-accent-600 text-sm"></i>
              <span className="text-accent-700 text-xs font-medium">平台优势</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              为什么选择我们
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              三大核心优势，重新定义你的4K观影体验
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {featureItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 rounded-2xl p-6 md:p-8 cursor-pointer hover:bg-background-50 transition-colors"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 mb-5 group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-primary-600 text-2xl md:text-3xl`}></i>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}